import React, { useMemo } from "react";
import { EXPANSION, getFormattedContentType, SEASON } from "../../lib/wowHelpers";
import MediaQuery from "components/MediaQuery";

const DataDetails = (props) => {
  const {
    encounterType,
    timestamp,
    parses,
    useDetailedTitle = false,
    isTierList = false,
    ratingRange,
    maxMythicKey,
    minMythicKey,
    numLogsTitle,
  } = props;
  const encounterTitle = useMemo(() => {
    let encounterTitle = getFormattedContentType(encounterType);
    if (isTierList && encounterType === "raid") {
      encounterTitle = `${EXPANSION} Season ${SEASON} Raid`;
    } else if ((encounterType === "mythic" || encounterType === "PvP") && useDetailedTitle) {
      encounterTitle += ` ${EXPANSION} Season ${SEASON}`;
    }
    return encounterTitle;
  }, [encounterType, useDetailedTitle]);

  return (
    <div className="data-details-container">
      <p>
        <span className="data-details-text">{encounterTitle}</span>
        <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM" renderNullOnFail>
          <br />
        </MediaQuery>{" "}
        <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE" renderNullOnFail>
          <span className="backslash">/</span>
        </MediaQuery>
        Last Updated: <span className="data-details-text">{timestamp}</span> <span className="backslash">/</span>{" "}
        {encounterType === "mythic" && isTierList == false ? (
          <>
            Key Range:{" "}
            <span className="data-details-text">
              {minMythicKey}-{maxMythicKey}
            </span>
            <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM" renderNullOnFail>
              <br />
            </MediaQuery>{" "}
            <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE" renderNullOnFail>
              <span className="backslash">/</span>
            </MediaQuery>
          </>
        ) : null}
        {encounterType === "PvP" ? (
          <>
            Rating Range: <span className="data-details-text">{ratingRange}</span>
            <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM" renderNullOnFail>
              <br />
            </MediaQuery>{" "}
            <MediaQuery min="MOBILE_LARGE" max="DESKTOP_LARGE" renderNullOnFail>
              <span className="backslash">/</span>
            </MediaQuery>
          </>
        ) : null}
        {numLogsTitle}: <span className="data-details-text">{parses.toLocaleString("en-US")}</span>
      </p>
    </div>
  );
};

export default DataDetails;
